import { Context } from './context';

/**
 * Possible event types allowed for webservices associated events
 */
export enum WSEventType {
  STARTED = 'Started',
  LOADED = 'Loaded',
}

/**
 * Enum of possible status of a webservice
 */
export enum WSElementType {
  OK = 'ok',
  ERROR = 'error',
  ERROR_TIMEOUT = 'error-timeout',
}

export const JS_ERROR = 'js-error';

export enum SondaType {
  WS = 'ws',
  EVENT = 'event',
  ERROR_HANDLER = 'Error-Handler',
  EXTERNAL_FLOW = 'External-Flow',
}

export type SondaInfo = {
  // Trazas
  wbSessionId: string;
  uiGAClientId: string;
  // Contextual
  cdContext: string;
  cdSource: string;
  cdEnvironment: string;
  cdSegment: string;
  cdUserAgent: string;
  cdTimeStamp: string;
  cdUrl: string;
  cdReferer: string;
  // Evento
  // -> Identificador único.
  ctzId: string;
  // -> Tipo ('ws' | 'chat' | 'ctz').
  cdType: string;
  // -> Nombre del evento.
  cdEventName: string;
  // -> Tipo de Evento solo para WebServices ('Started' | 'Loaded').
  cdEventType: string;
  // -> Estado del Evento WebService ('ok', 'error', 'js-error', 'error-timeout').
  cdElementType: string;
  // -> Información adicional (datos)
  cData: string;
  // -> Contexto del WebService
  wsContext: string;
  // --> Nombre del WebService (El mismo que el del Evento)
  wsName: string;
  // --> Estado del WebService (El mismo que el WSElementType)
  status: string;
  // --> Información del usuario. Legado/Telco/"" y si es telco con idParty.
  userInfo: string;
};
export interface Sonda {
  eventName: string;
  origin: string;
  context: Context;
  uniqueId: string;
  sendInfoToCtzMetricsData(
    type: SondaType,
    eventName: string,
    info?: any,
    wsEventType?: WSEventType,
    elementType?: WSElementType | string,
  ): void;
  startWS(info?: any): void;
  startExternalFlow(status: WSElementType, info?: any): void;
  endWS(status: WSElementType, info?: any): void;
  endExternalFlow(status: WSElementType, info?: any): void;
  sondaEvent(info: any, type: SondaType): void;
  errorJs(jsError: any): void;
}
